import { QueryKey, useQueryClient, UseQueryResult } from '@tanstack/react-query';

export const isObjectRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null;

export type GetQueryStatesResultParams<T> = Pick<
    UseQueryResult<T>,
    | 'isLoading'
    | 'isSuccess'
    | 'isError'
    | 'isFetching'
    | 'isPending'
    | 'isStale'
    | 'isFetched'
    | 'isRefetching'
    | 'isPlaceholderData'
>;

export const getQueryStates = <T extends GetQueryStatesResultParams<unknown>>(results: T[]) => {
    const isLoading = results.some((result) => result.isLoading);
    const isSuccess = results.every((result) => result.isSuccess);
    const isError = results.some((result) => result.isError);
    const isFetching = results.some((result) => result.isFetching);
    const isPending = results.some((result) => result.isPending);
    const isStale = results.some((result) => result.isStale);
    const isFetched = results.every((result) => result.isFetched);
    const isRefetching = results.some((result) => result.isRefetching);
    const isPlaceholderData = results.some((result) => result.isPlaceholderData);

    return {
        isLoading,
        isSuccess,
        isError,
        isFetching,
        isPending,
        isStale,
        isFetched,
        isRefetching,
        isPlaceholderData,
    };
};

export const invalidateCache = (queryClient: ReturnType<typeof useQueryClient>, keys: QueryKey[]) => () => {
    keys.forEach((queryKey) => queryClient.invalidateQueries({ queryKey }));
};
